import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'
import Sidebar from './Sidebar'
import Header from './Header'
import CopilotWidget from '../copilot/CopilotWidget'
import { getMerchant } from '../../services/merchant'
import { useMerchantStore } from '../../stores/merchantStore'
import AnnouncementShell from '../announcements/AnnouncementShell'
import MerchantAgreementGate from '../legal/MerchantAgreementGate'

const { Content } = Layout

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(() => window.matchMedia('(max-width: 768px)').matches)
  const setMerchant = useMerchantStore((state) => state.setMerchant)

  const handleSidebarNavigate = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      setCollapsed(true)
    }
  }

  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)')
    const syncCollapsed = () => setCollapsed(media.matches)
    syncCollapsed()
    media.addEventListener('change', syncCollapsed)
    return () => media.removeEventListener('change', syncCollapsed)
  }, [])

  useEffect(() => {
    getMerchant()
      .then((res) => setMerchant(res.data))
      .catch(() => {})
  }, [setMerchant])

  return (
    <Layout className="dashboard-layout">
      <Sidebar collapsed={collapsed} onNavigate={handleSidebarNavigate} />
      <Layout>
        <AnnouncementShell>
          {(announcementHeader, urgentAnnouncementActive, onAgreementDialogsClosed) => (
            <>
              <Header collapsed={collapsed} setCollapsed={setCollapsed} announcementHeader={announcementHeader} />
              <Content className="dashboard-content">
                <MerchantAgreementGate
                  urgentAnnouncementActive={urgentAnnouncementActive}
                  onAgreementDialogsClosed={onAgreementDialogsClosed}
                >
                  <Outlet />
                </MerchantAgreementGate>
              </Content>
            </>
          )}
        </AnnouncementShell>
      </Layout>
      <CopilotWidget />
    </Layout>
  )
}
